var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, FlexBox, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { loginApi } from 'apis/login';
import { emulateLinkInteraction } from 'app/utils/emulateLinkInteraction/emulateLinkInteraction';
import { analytics } from 'app/utils/segment';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from './organizationsNavigation.module.scss';
import { getOrganizationUrl } from './utils/get-organization-url';
/**
 * Represents the component where organizations available to the user are
 * displayed and can be navigated between.
 */
export const OrganizationsNavigation = ({ className, }) => {
    const [createLoginToken] = loginApi.useCreateLoginTokenMutation();
    const organizations = useAppSelector((state) => state.app.organizations);
    const currentOrganization = useAppSelector((state) => state.app.organization);
    const openOrganization = (event, organization) => __awaiter(void 0, void 0, void 0, function* () {
        analytics.organizationsNavigationOrganizationClicked({
            id: organization.id,
            name: organization.name,
            subdomain: organization.subdomain,
        });
        const { data: loginTokenData } = yield createLoginToken().unwrap();
        const navigateToUrl = getOrganizationUrl({
            loginToken: loginTokenData.login_token,
            organization: organization,
            url: new URL(window.location.href),
        });
        emulateLinkInteraction(navigateToUrl, event);
    });
    const handleOnKeyDown = (event, organization) => {
        if (event.key === 'Enter') {
            openOrganization(event, organization);
        }
    };
    const handleOnClick = (event, organization) => openOrganization(event, organization);
    const rootClass = classnames(styles.root, className);
    return (_jsx(FlexBox, Object.assign({ as: "nav", className: rootClass, "aria-label": "Organizations", padding: "200 250", flexDirection: "column", display: "flex", gap: "250" }, { children: organizations === null || organizations === void 0 ? void 0 : organizations.map((organization) => (_jsx(Tooltip, Object.assign({ content: organization.name, side: "right", dark: true }, { children: _jsx(FlexBox, Object.assign({ tabIndex: 0, onClick: (event) => handleOnClick(event, organization), onKeyDown: (event) => handleOnKeyDown(event, organization), role: "link", className: classnames({
                    [styles.active]: (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id) === organization.id,
                }, styles.item) }, { children: _jsx(Avatar, { size: "24", className: styles.avatar, user: {
                        id: organization.id,
                        avatar_url: organization.avatar_url,
                        name: organization.name,
                    } }) })) }), organization.id))) })));
};
